<template>
    <div class="history-section" id="history">
        <div class="container">
            <div class="about-section-title">
                <h2>Наша история</h2>
            </div>
            <div class="history-items">
                <swiper :options="swiperOption" ref="aboutHistoryCarousel">
                    <swiper-slide v-for="item in aboutPage.history_cards">
                        <div class="item">
                            <div class="item-year">
                                {{ item.year }} 
                                <span>ГОД</span>
                            </div>
                            <div class="item-desc">
                                <p v-for="descItem in item.desc_list">{{ descItem.desc }}</p>
                            </div>
                        </div>
                    </swiper-slide>
                </swiper>
                <div class="swiper-controls history-controls">
                    <div class="history-btn-prev slider-btn">
                        <svgIcon name="left-arrow" class="icon icon-arrow-left"/>
                    </div>
                    <div class="swiper-pagination history-sales-pagination"></div>
                    <div class="history-btn-next slider-btn">
                        <svgIcon name="right-arrow" class="icon icon-arrow-right"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import svgIcon from '@/components/partials/SvgIcon.vue';
    export default {
        name: 'history-section',
        components: {
            svgIcon,
        },
        data () {
            return {
                swiperOption: {
                    speed: 800,
                    loop: false,
                    observer: true,
                    spaceBetween: 30,
                    // effect: 'slide',
                    slidesPerView: 4,
                    simulateTouch: true,
                    navigation: {
                        nextEl: '.history-btn-next',
                        prevEl: '.history-btn-prev',
                    },
                    pagination: {
                        el: '.history-sales-pagination',
                        type: 'bullets',
                        clickable: true,
                    },
                    breakpoints: {
                        // when window width is >= 900px
                        900: {
                            slidesPerView: 'auto',
                            spaceBetween: 20
                        },
                    }
                }
            }
        },
        computed: mapGetters({
            aboutPage: 'loadAboutPage',
        }),
        methods: {
        },
        created () {
        },
        mounted() {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/about/history-section.scss';
    @import '@/styles/components/about/respond/history-section-respond.scss';
</style>